export function normalizeURL(url = document.URL) {
  const actualUrl = url ?? ''

  return actualUrl.toLowerCase()
}
